/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_AmountInputs */

const vi_cashflow_amount = /** @type {(inputs: Cashflow_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền`)
};

/**

* @param {Cashflow_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_amount = /** @type {((inputs?: Cashflow_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_amount(inputs)
});